import { Icon } from '@zoom/components';
import classnames from 'classnames';
import { TFunction } from 'i18next';
import React from 'react';

import { FILTER_SIDEBAR_DROPDOWN_TOGGLE, RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG } from './constants';
import {
  DropdownItem,
  IUncontrolledDropdown,
  UncontrolledDropdown,
} from '../../components/Dropdown/UncontrolledDropdown';

type SchedulingStudioFilterSidebarDropdownProps = {
  isFilterActive: boolean;
  resetAllFilters: () => void;
  t: TFunction;
};

export const SchedulingStudioFilterSidebarDropdown: React.FC<SchedulingStudioFilterSidebarDropdownProps> = ({
  isFilterActive,
  resetAllFilters,
  t,
}) => {
  const dropdownProps: IUncontrolledDropdown = {
    className: 'dropdown-menu-basic ml-auto',
    toggle: {
      dataTestId: FILTER_SIDEBAR_DROPDOWN_TOGGLE,
      children: <Icon kind="menu-kebab" color="#00a8e2" size={20} />,
      props: {
        color: 'info',
      },
    },
    menu: {
      props: {
        modifiers: {
          offset: {
            enabled: true,
            offset: '-123, 10',
          },
          preventOverflow: {
            // To be able set negative x position
            enabled: true,
            boundariesElement: 'window',
          },
        },
      },
      children: (
        <DropdownItem
          data-test-id={RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG}
          onClick={resetAllFilters}
          className={classnames({ 'dropdown-item--disabled': !isFilterActive })}
          disabled={!isFilterActive}
        >
          <Icon kind="cross" height={14} color="orange" />
          {t('filter.resetAllFilters')}
        </DropdownItem>
      ),
    },
  };

  return <UncontrolledDropdown {...dropdownProps} />;
};
